import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsTimeslotKindException from 'graphql/fields/FieldsTimeslotKindException'
import FieldsTimeslotKind from 'graphql/fields/FieldsTimeslotKind'

const fields = {
	'guid': 'String',
	'timeslot_kind_guid': 'String',
	'available_for': 'String',
	'can_book_from': 'String',
	'can_book_until': 'String',
	'can_cancel_until': 'String',
	'active': 'String!',
};

export default gql(`
	mutation timeslot_kind_exception( ${ HelperGraphql.createFields( fields ) } ) {
	    timeslot_kind_exception( ${ HelperGraphql.createVariables( fields ) } ) {
	       ${FieldsTimeslotKindException}
	       
			timeslot_kind {
				${FieldsTimeslotKind}
			}
	    }
	}
`);

